module.exports = {"410103001":"淮河路街道","410103002":"解放路街道","410103003":"铭功路街道","410103004":"一马路街道","410103005":"蜜蜂张街道","410103006":"五里堡街道","410103007":"大学路街道","410103008":"建中街街道","410103009":"福华街街道","410103010":"德化街街道","410103011":"嵩山路街道","410103012":"京广路街道","410103013":"长江路街道","410103015":"人和路街道","410103016":"侯寨街道","410103100":"马寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410103.json
// module id = 1514
// module chunks = 0